import { CREATE_TRANSACTION_STATUS } from "../action.js";

export const setTransactionStatus = (status) => {
    return (dispatch) => {
        dispatch({ type: CREATE_TRANSACTION_STATUS, payload: status });
    };
};